var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 220,
    viewBox: "0 0 188 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.421 113.179C173.6 112.674 174.946 112.421 176.377 112.421C181.93 112.421 186.475 116.966 186.475 122.52C186.475 128.074 181.93 132.618 176.377 132.618C175.198 132.618 174.104 132.449 173.01 132.029",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6079 97.2744C71.9445 97.2744 76.5167 100.64 78.7608 102.324",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2432 99.7988C54.2726 98.7889 58.6485 95.0021 60.4998 92.3934C62.3512 89.7847 65.1282 87.2602 68.3259 87.6809C71.3554 88.1017 73.4592 91.2995 73.5433 94.3289C73.7116 97.3584 72.3652 100.304 70.8505 102.997C66.3904 111.328 58.0594 119.743 51.2432 126.306V99.7988Z",
    fill: "#CEEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 126.727H156.938",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 74.5532H156.938",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 186.054L80.0232 208.775M86.3346 204.988L142.716 168.803",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.922 127.569V0.5",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4298 35.3388C67.5687 44.5113 64.7917 53.6838 61.9305 62.7722C61.5939 63.9503 63.3611 64.4552 63.7819 63.2771C66.643 54.1046 69.42 44.9321 72.2812 35.8437C72.6178 34.7497 70.7664 34.2448 70.4298 35.3388Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 6.6582C51.5 3.89678 53.7386 1.6582 56.5 1.6582H150.5C153.261 1.6582 155.5 3.89678 155.5 6.6582V135.658H51.5V6.6582Z",
    stroke: "#5F6368",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7019 54.4411C72.197 56.2924 71.7762 58.2279 71.2713 60.0793C71.1872 60.5842 71.4396 61.0891 71.9445 61.2574C72.4494 61.3415 72.9544 61.0891 73.1227 60.5842C73.6276 58.7328 74.0483 56.7973 74.5532 54.946C74.6374 54.4411 74.3849 53.9362 73.88 53.7679C73.3751 53.6837 72.8702 53.9362 72.7019 54.4411Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.189 102.323V143.557H134.638V102.323C134.638 102.323 138.677 106.531 154.413 106.531C170.15 106.531 174.189 102.323 174.189 102.323Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2363 155.002C24.9273 155.002 31.9726 147.957 31.9726 139.266C31.9726 130.575 24.9273 123.529 16.2363 123.529C7.54539 123.529 0.5 130.575 0.5 139.266C0.5 147.957 7.54539 155.002 16.2363 155.002Z",
    fill: "#FAD2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.647 114.946C14.7213 113.852 13.7956 112.674 12.5334 112.084C11.2711 111.495 9.5039 111.58 8.66239 112.589C7.40011 114.104 8.57823 116.544 10.3454 117.386C12.1126 118.228 14.2164 117.891 16.0677 117.554",
    stroke: "#5F6368",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9837 114.609C16.9094 113.515 17.8351 112.337 19.0973 111.748C20.3596 111.159 22.1268 111.243 22.9683 112.253C24.2306 113.768 23.0525 116.208 21.2853 117.05C19.5181 117.891 17.4143 117.554 15.563 117.218",
    stroke: "#5F6368",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54938 139.603C7.14826 139.603 7.14826 137.078 5.54938 137.078C3.86635 137.078 3.86635 139.603 5.54938 139.603Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31635 146.335C8.91522 146.335 8.91522 143.81 7.31635 143.81C5.71747 143.81 5.71747 146.335 7.31635 146.335Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8603 142.464C13.4592 142.464 13.4592 139.939 11.8603 139.939C10.2614 139.939 10.2614 142.464 11.8603 142.464Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3105 148.607C16.9094 148.607 16.9094 146.082 15.3105 146.082C13.7116 146.082 13.7116 148.607 15.3105 148.607Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5981 150.29C12.197 150.29 12.197 147.765 10.5981 147.765C8.9992 147.765 8.9992 150.29 10.5981 150.29Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.672 164.595L138.929 156.601L175.535 170.906L146.923 203.305C142.155 201.481 130.682 197.33 122.94 195.31C115.198 193.291 109.336 191.944 107.372 191.523",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2363 123.529C7.56872 123.529 0.5 130.598 0.5 139.266C0.5 141.79 1.08906 144.146 2.09888 146.166L25.9979 126.895C23.305 124.792 19.939 123.529 16.2363 123.529Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.413 106.531C164.637 106.531 172.926 104.647 172.926 102.323C172.926 99.9995 164.637 98.1157 154.413 98.1157C144.188 98.1157 135.899 99.9995 135.899 102.323C135.899 104.647 144.188 106.531 154.413 106.531Z",
    fill: "white",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58 105.184L134.638 127.148V101.902L143.053 106.11L160.304 106.362L171.58 105.184Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.043 202.464L29.8691 182.267L90.4582 147.765L142.632 163.754L82.043 202.464Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.12 196.236L147.26 218.621L118.06 206.25C118.06 206.25 133.712 192.365 141.622 185.465L167.12 196.236Z",
    fill: "#DADCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5689 95.6749C69.1678 95.6749 69.1678 93.1504 67.5689 93.1504C65.8859 93.1504 65.8859 95.6749 67.5689 95.6749Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8057 107.372L16.4887 124.623",
    stroke: "#5F6368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 219,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoClass);
export default __webpack_public_path__ + "static/media/no_class.bf183849a6551c532f56e6962315c4b5.svg";
export { ForwardRef as ReactComponent };